export const REQUEST_DELIVERIES_LISTINGS = "REQUEST_DELIVERIES_LISTINGS";
export const SET_DELIVERIES_LISTINGS = "SET_DELIVERIES_LISTINGS";
export const REVOKE_DELIVERIES_LISTINGS = "REVOKE_DELIVERIES_LISTINGS";
export const RESET_DELIVERIES_LISTINGS = "RESET_DELIVERIES_LISTINGS";

export const CHANGE_DELIVERIES_MODALS = "CHANGE_DELIVERIES_MODALS";

export const REQUEST_ADD_SINGLE_DELIVERY = "REQUEST_ADD_SINGLE_DELIVERY";
export const REVOKE_ADD_SINGLE_DELIVERY = "REVOKE_ADD_SINGLE_DELIVERY";
export const RESET_ADD_SINGLE_DELIVERY = "RESET_ADD_SINGLE_DELIVERY";
export const GRANT_ADD_SINGLE_DELIVERY = "GRANT_ADD_SINGLE_DELIVERY";
